import React, { useState } from 'react';
import {
  Box,
  Button,
  Grid,
  InputAdornment,
  InputBase,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { styled } from '@mui/system';
import { useDispatch } from 'react-redux';
import { openModal } from '../../../redux/slices/profileSlice';
import CustomModal from '../../CustomModal';

/* -------------------- Styled Components -------------------- */

const AvailableBalanceTxt = styled(Typography)({
  fontSize: '20px',
  fontWeight: 600,
});

const WithdrawInputBox = styled(Stack)({
  background: '#f5f5f5',
  height: '45px',
  borderRadius: '8px',
  padding: '6px 12px',
  alignItems: 'center',
});

const SuggestedBox = styled(Box)(({ selected }) => ({
  background: '#E6C200',
  padding: '12px',
  borderRadius: '8px',
  textAlign: 'center',
  cursor: 'pointer',
  fontWeight: 700,
  border: selected ? '3px solid #ff4d4f' : '3px solid transparent',
}));

const ConfirmBtn = styled(Box)({
  background: '#E63946',
  padding: '15px',
  borderRadius: '12px',
  marginTop: '20px',
  cursor: 'pointer',
  color: '#fff',
});

/* -------------------- Static Data -------------------- */

const staticBalance = 3500.0;
const staticCurrency = 'MYR';

const staticBankAccounts = [
  { id: 1, account: '123456789 - Maybank' },
  { id: 2, account: '987654321 - CIMB' },
];

const staticSuggestedAmounts = [250, 300, 500, 800, 2000, 10000];

/* -------------------- Component -------------------- */

const WithdrawDialog = ({ handleClose, handleOpen }) => {
  const [withdrawAmount, setWithdrawAmount] = useState('');
  const [selectedBank, setSelectedBank] = useState(staticBankAccounts[0].id);
  const dispatch = useDispatch();

  const handleWithdraw = () => {
    if (!withdrawAmount) {
      alert('Please enter amount');
      return;
    }

    if (Number(withdrawAmount) > staticBalance) {
      alert('Amount cannot exceed balance');
      return;
    }

    alert(`Withdraw Successful: ${staticCurrency} ${withdrawAmount}`);
  };

  return (
    <CustomModal
      hasClose
      maxWidth="sm"
      open={handleOpen}
      onClose={handleClose}
      actions={
        <ConfirmBtn onClick={handleWithdraw}>
          <Stack direction="row" justifyContent="space-between">
            <Typography fontWeight={700}>Withdraw</Typography>
            <Typography fontWeight={700}>
              {staticCurrency} {withdrawAmount || '0.00'}
            </Typography>
          </Stack>
        </ConfirmBtn>
      }
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          px: 3,
          py: 2,
        }}
      >
        <AvailableBalanceTxt>Available Balance</AvailableBalanceTxt>
        <Typography mb={2}>
          {staticCurrency} {staticBalance.toFixed(2)}
        </Typography>

        {/* Amount */}
        <Typography mb={1}>
          <span style={{ color: 'red' }}>*</span> Amount
        </Typography>

        <TextField
          placeholder="Enter Amount"
          value={withdrawAmount}
          onChange={(e) => setWithdrawAmount(e.target.value)}
          fullWidth
          size="small"
          variant="outlined"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="body2" sx={{ color: '#555', fontWeight: 'bold' }}>
                  {staticCurrency}
                </Typography>
              </InputAdornment>
            ),
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '12px',
              backgroundColor: '#F3F4F6',
              '& fieldset': {
                border: 'none',
              },
              '&:hover fieldset': {
                border: 'none',
              },
              '&.Mui-focused fieldset': {
                border: '1px solid #E0E0E0',
              },
            },
            '& input': {
              padding: '12px 8px',
            },
            '& input::placeholder': {
              color: '#9CA3AF',
              opacity: 1,
              fontWeight: 400,
            },
          }}
        />

        <Button
          onClick={() =>
            dispatch(
              openModal({
                view: 'add-bank-account',
              })
            )
          }
          variant="contained"
          sx={{ mt: 2 }}
        >
          Add Bank Account
        </Button>
        {/* Suggested Amounts */}
        <Grid container spacing={2} mt={1}>
          {staticSuggestedAmounts.map((amount) => (
            <Grid item xs={4} key={amount}>
              <SuggestedBox selected={withdrawAmount === amount} onClick={() => setWithdrawAmount(amount)}>
                {amount.toFixed(2)}
              </SuggestedBox>
            </Grid>
          ))}
        </Grid>

        {/* Bank Account */}
        {/* <Typography mt={3} mb={1}>
          <span style={{ color: 'red' }}>*</span> Bank Account
        </Typography> */}

        {/* <Select fullWidth value={selectedBank} onChange={(e) => setSelectedBank(e.target.value)}>
          {staticBankAccounts.map((bank) => (
            <MenuItem key={bank.id} value={bank.id}>
              {bank.account}
            </MenuItem>
          ))}
        </Select> */}
      </Box>
    </CustomModal>
  );
};

export default WithdrawDialog;
